import React, { useEffect, useRef } from 'react';

// فیلمِ بی‌صدا و تکرارشونده‌ی طرح؛ فقط وقتی (به‌قدرِ کافی) روی صفحه است پخش می‌شود — باتری و داغ نشدنِ گوشی.
// active (اختیاری): اگر داده شود، به‌جای دیدن روی صفحه همین تعیین می‌کند پخش شود یا نه (ریلز)
// onReady: وقتی به‌قدرِ کافی دانلود شد که بی‌وقفه پخش شود (canplaythrough)
function LoopVideo({ src, poster, className, active, threshold = 0.25, preload = 'metadata', onReady }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    el.muted = true; // بعضی مرورگرها فقط با این (نه فقط ویژگیِ muted) خودکار پخش می‌کنند
    if (active !== undefined) {
      if (active) el.play().catch(() => {});
      else el.pause();
      return undefined;
    }
    if (typeof IntersectionObserver === 'undefined') {
      el.play().catch(() => {});
      return undefined;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) el.play().catch(() => {});
        else el.pause();
      },
      { threshold }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [src, active, threshold]);
  return (
    <video
      ref={ref}
      className={className}
      src={src}
      poster={poster || undefined}
      muted
      loop
      playsInline
      preload={preload}
      onCanPlayThrough={onReady || undefined}
    />
  );
}

// کدام نسخه‌ی فیلم (designs/filmTranscode.js روی سرور): filmUrl = ۷۲۰p سبک (یا اصل اگر هنوز تبدیل نشده)،
// filmSmUrl = ۳۶۰p خیلی سبک. small: کاشیِ کوچک (پروفایل/ذخیره‌شده‌ها) — همیشه نسخه‌ی کوچک. اینترنتِ ضعیف
// (اندروید خبر می‌دهد؛ آیفون نه) یا «صرفه‌جویی در داده» → نسخه‌ی کوچک
export function slowNetwork() {
  const c = typeof navigator !== 'undefined' ? navigator.connection : null;
  if (!c) return false;
  return Boolean(c.saveData) || ['slow-2g', '2g', '3g'].includes(c.effectiveType) || (c.downlink > 0 && c.downlink < 1.5);
}
export function filmSrc(d, small = false) {
  if (!d) return null;
  return (small || slowNetwork()) && d.filmSmUrl ? d.filmSmUrl : d.filmUrl || null;
}

export default LoopVideo;
